import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {AgentEventType, IAgentEvent} from '../live/agent-live/model/IAgentEvent';
import {IUser} from '../../../users/users';
import {MIHttpClientService} from '../../../shared/mi-http-client.service';
import {SecureLocalService} from '../../../core/secure-local.service';

@Injectable({
  providedIn: 'root',
})
export class VibaEventsService {

  constructor(
    private miClient: MIHttpClientService,
    private secureService: SecureLocalService,
    private http: HttpClient
  ) {
  }

  public startChat(callId: string, callerId: string, endpointId: number) {
    this.submitNewRelicChatEvent(AgentEventType.AGENT_CHAT_START, VibaEventsService.getCurrentOrg(), callId, callerId, endpointId);
  }

  public endChat(callId: string, callerId: string, endpointId: number) {
    this.submitNewRelicChatEvent(AgentEventType.AGENT_CHAT_END, VibaEventsService.getCurrentOrg(), callId, callerId, endpointId);
  }

  public acceptChatToCallRequest(callId: string, callerId: string, endpointId: number) {
    this.submitNewRelicChatEvent(AgentEventType.AGENT_ACCEPT_CHAT_TO_CALL_REQUEST, VibaEventsService.getCurrentOrg(), callId, callerId, endpointId);
  }

  public denyChatToCallRequest(callId: string, callerId: string, endpointId: number) {
    this.submitNewRelicChatEvent(AgentEventType.AGENT_DENY_CHAT_TO_CALL_REQUEST, VibaEventsService.getCurrentOrg(), callId, callerId, endpointId);
  }

  private submitNewRelicChatEvent(eventType: AgentEventType, orgId: number, callId: string, callerId: string, endpointId: number) {
    const currentUser: IUser = JSON.parse(localStorage.getItem('currentUser'));
    this.submitNewRelicEvent({
      eventType: eventType, userId: currentUser.userId, endpointId: endpointId,
      source: 'browser', callId: callId, callerId: callerId, orgId: orgId
    });
  }

  public submitNewRelicEvent(event: IAgentEvent) {
    event.domain = window.location.host;
    const url = 'https://insights-collector.newrelic.com/v1/accounts/2953354/events';
    const options = {
      headers: new HttpHeaders().set('Content-Type', 'application/json').set('X-Insert-Key', 'NRII-x6WrEBZmxNgkVQxXg2018bnYeLh2b4GZ')
    };
    return this.http.post(url, JSON.stringify(event), options).subscribe((data) => {
      // @ts-ignore
      if (data.success) {
        console.log(event.eventType + ' ' + event.orgId + ' submitted successfully to NewRelic');
      }
    });
  }

  private static getCurrentOrg(): number {
    return Number(localStorage.getItem('selectedOrganization'));
  }
}


